import { reviews } from '@/mocks/reviews';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

export default function ReviewsSection() {
  const { ref, isVisible } = useScrollAnimation(0.1);

  return (
    <section id="avis" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div ref={ref} className={`text-center transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            Nos clients parlent de nous
          </h2>
          <div className="mt-4 flex items-center justify-center gap-3">
            <div className="flex items-center gap-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <i
                  key={star}
                  className={`ri-star-fill w-5 h-5 flex items-center justify-center text-lg ${
                    star <= 4 ? 'text-yellow-400' : 'text-yellow-300'
                  }`}
                />
              ))}
            </div>
            <div className="text-left">
              <p className="font-heading font-bold text-2xl text-foreground-900 leading-none">4,9 / 5</p>
              <p className="text-foreground-500 text-sm">15 avis Google</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mt-8 md:mt-12">
          {reviews.map((review, idx) => {
            const isFeatured = idx === Math.floor(reviews.length / 2);
            return (
              <div
                key={review.name}
                className={`bg-white rounded-lg p-6 md:p-7 border transition-all duration-500 hover:-translate-y-1 ${
                  isFeatured
                    ? 'border-primary-300 bg-primary-50/40 lg:scale-[1.04]'
                    : 'border-background-200 hover:border-primary-200'
                } ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${idx * 100}ms` }}
              >
                <div className="flex items-center gap-1 mb-3">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i
                      key={star}
                      className="ri-star-fill w-5 h-5 flex items-center justify-center text-yellow-400 text-base"
                    />
                  ))}
                </div>
                <p className="text-foreground-700 text-[15px] leading-relaxed italic">
                  "{review.text}"
                </p>
                <p className="text-foreground-900 font-semibold text-[15px] mt-3">
                  — {review.name}
                </p>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-10 md:mt-12">
          <a
            href="https://www.google.com/search?q=easy+car+le+tampon+avis"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-foreground-300 text-foreground-700 font-label font-medium text-sm hover:border-primary-500 hover:text-primary-600 transition-all whitespace-nowrap"
          >
            <i className="ri-google-fill w-4 h-4 flex items-center justify-center" />
            Voir nos avis Google
          </a>
        </div>
      </div>
    </section>
  );
}